"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SELECTED_ICE_CANDIDATE_METRIC_MUTATION = exports.PING = exports.SIGNAL_MUTATION = exports.EMIT_SIGNAL_TYPE = exports.SIGNAL_SUBSCRIPTION = exports.SIGNAL_RECEIVED_TYPE = void 0;
const core_1 = require("@apollo/client/core");
exports.SIGNAL_RECEIVED_TYPE = "signalingSignalReceived";
exports.SIGNAL_SUBSCRIPTION = (0, core_1.gql) `
  subscription SignalSubscription {
    ${exports.SIGNAL_RECEIVED_TYPE} {
      event
      sdp
      source
      uuid
    }
  }
`;
exports.EMIT_SIGNAL_TYPE = "signalingEmitSignal";
exports.SIGNAL_MUTATION = (0, core_1.gql) `
  mutation SignalMutation(
    $uuid: String!
    $sdp: String!
    $event: SignalEventType!
    $source: SignalSourceType!
  ) {
    ${exports.EMIT_SIGNAL_TYPE}(
      input: { uuid: $uuid, sdp: $sdp, event: $event, source: $source }
    ) {
      event
      sdp
      source
      uuid
    }
  }
`;
exports.PING = (0, core_1.gql) `
query MyQuery {
	ping
}
`;
exports.SELECTED_ICE_CANDIDATE_METRIC_MUTATION = (0, core_1.gql) `
mutation SelectedICECandidateMetricMutation(
  $fields: [MetricFieldInput!]
) {
  metricCreate(
		input: {
    	name: "selectedicecandidate",
      fields: $fields
    }
  ) {
    name,
    fields {
      name,
      type,
      value
    }
  }
}
`;
//# sourceMappingURL=graphql.js.map